<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-form ref="create" @submit.prevent="createPromotion">
        <v-card elevation="6">
          <div class="grid-half">
            <div class="grid-list">
              <div class="ma-3">
                <v-text-field color="#86bc3a" label="ชื่อโปรโมชั่น" :rules="[v => !!v || 'กรุณากรอกชื่อโปรโมชั่น']" v-model="save_list.promotion_name" hide-details="auto" required outlined></v-text-field>
              </div>
              <div class="ma-3">
                <v-text-field color="#86bc3a" type="number" @keypress="onlyNumber($event, save_list.per_unit)" label="ราคาขายต่อหน่วย" :rules="[v => !!v || 'กรุณากรอกราคาขายต่อหน่วย']" v-model="save_list.per_unit" hide-details="auto" required outlined></v-text-field>
              </div>
              <div class="ml-3 mr-3 mt-3">
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable color="#86bc3a" v-model="date" label="วันที่สิ้นสุดโปรโมชั่น (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณาระบุวันที่สิ้นสุดโปรโมชั่น']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDate(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="grid_full">
            <div class="ma-3 margin_top">
              <v-textarea color="#86bc3a" type="text" label="หมายเหตุ" v-model="save_list.promotion_note" prepend-inner-icon="mdi-message-bulleted" hide-details="auto" outlined></v-textarea>
            </div>
          </div>
          <div class="mt-2 ma-4">
            <headerexpire_promotion :product_name="header_list.product_name" :expire_product="header_date" name="จำนวนรวม" :unit="total_grand" :unit_name="header_list.unit"/>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_list" :search="search" mobile-breakpoint="0" hide-default-footer>
              <template v-slot:item="dataDetail" class="grid_btn">
                <tr>
                  <td>
                    <v-checkbox color="#86bc3a" class="ma-0" v-model="dataDetail.item.status_check" @click="total()" hide-details="auto"></v-checkbox>
                  </td>
                  <td>{{ dataDetail.item.lot_no }}</td>
                  <td>{{ diffDateTH(dataDetail.item.date_expired) }}</td>
                  <td>{{ format_number(dataDetail.item.quantity) }}</td>
                  <td>{{ dataDetail.item.supplier }}</td>
                  <td>{{ format_price(dataDetail.item.cost) }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div class="text-center mt-4 pb-4">
            <v-btn height="45" class="white--text grad-success-bg btn_size" type="submit">บันทึกข้อมูล</v-btn>
          </div>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import headerexpire_promotion from "@/components/admin/stock/storage_promotion/header_promotion/headerexpire_promotion";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice, minDate, onlyForCurrency} from "@/js/handler";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_manage_exp",
  components: {
    headerexpire_promotion
  },
  data() {
    return {
      loading_page: false,
      search: null,
      ck_1: false,
      menu_date: false,
      date: '',
      dateEN: '',
      start_date: this.min_Date(),
      total_grand: 0,
      headers: [
        {
          text: 'เลือก',
          value: '',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ล็อต',
          value: '',
          fixed: true,
          width: '180px',
        },
        {
          text: 'วันหมดอายุ',
          value: '',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: '',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: '',
          fixed: true,
          width: '300px',
        },
        {
          text: 'ราคาต้นทุน/หน่วย',
          value: '',
          fixed: true,
          width: '200px',
        },
      ],
      data_list: [],
      header_list: [],
      header_date: null,
      save_list: {
        promotion_name: null,
        per_unit: null,
        promotion_note: '-',
      },
    }
  },
  methods: {
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    min_Date: function () {
      return minDate()
    },
    onlyNumber: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      return day+'/'+month+'/'+year
    },
    diffDate(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/expireds/getproductid', {
        product_id: this.$route.params.id,
        type: this.$route.params.type,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.show
          this.header_date = res.data.show_date
          this.data_list = res.data.object
          this.expire_data = res.data.object
          res.data.object.forEach((data, index) => {
            this.data_list[index].status_check = false
          })
        }
      })
    },
    total() {
      let total_grand = 0
      let value = this.data_list.filter((data) => data.status_check === true)
      let result = value.reduce((sum, number) => {
        total_grand = number.quantity
        if (total_grand > 0) {
          return sum+(total_grand)
        }
        else {
          return sum+(0)
        }
      }, 0)
      return this.total_grand = result
    },
    createPromotion() {
      if (this.$refs.create.validate()) {
        const value = this.data_list.filter((data) => data.status_check === true)
        value.forEach((data) => {
          if (data.status_check === true) {
            data.status_check = 1
          }
          else {
            data.status_check = 0
          }
        })
        if (value.length > 0) {
          Swal.fire({
            title: 'ต้องการบันทึกข้อมูลหรือไม่ ?',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              HTTP.post('/inventory/promotions/expireds/create', {
                user_create: this.$store.state.userDetail.id,
                user_name: this.$store.state.userDetail.name,
                promotion_name: this.save_list.promotion_name,
                end_date: this.dateEN,
                per_unit: this.save_list.per_unit,
                promotion_note: this.save_list.promotion_note,
                total: this.total_grand,
                data_set: value,
              }).then((res) => {
                if (res.data.success === true) {
                  Swal.fire({
                    title: 'บันทึกข้อมูลสำเร็จ !',
                    icon: 'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then(() => {
                    this.$router.push('/stock/promotion_stock/promotionexp');
                  })
                }
              })
            }
          })
        }else {
          Swal.fire({
            title: 'กรุณาเลือกข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
    }
  },
  mounted() {
    this.get_data()
  }

}
</script>

<style scoped>
.btn_size {
  font-size: 18px;
}
.grid-half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid-list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.margin_top {
  margin-top: -5px !important;
}
@media only screen and (max-width: 1180px) {
  .grid-half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid-half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid-list {
    display: grid;
    grid-template-columns: 100%;
  }
  .margin_top {
    margin-top: -5px !important;
  }
}
</style>
